import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import SmtpEmail from "../../components/Admin/profileComps/email"

const ConnectSMTP = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Connect Email | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <SmtpEmail />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default ConnectSMTP
